<template>
  <div>
    <v-snackbar
    color="error"
    top
    v-model="snackbar"
    :timeout="5000"
    id="snackbar"
    >
      <v-row>
      {{text}}
      <v-spacer></v-spacer>
      <v-btn
        dark
        icon
        @click="snackbar = false"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      </v-row>
    </v-snackbar>
    <!-- radio group  -->
    <v-form ref="form">
      <v-row no-gutters justify="space-between">
        <v-radio-group row color="white" v-model="flightType" class="mb-2">
          <v-radio color="blueDark" value="round">
            <template v-slot:label>
              <span class="#333--text font-weight-medium mx-2" style="letter-spacing: 1.5px;">Round Trip</span>
            </template>
          </v-radio>
          <v-radio color="blueDark" value="one">
            <template v-slot:label>
              <span class="#333--text font-weight-medium mx-2" style="letter-spacing: 1.5px;">One Way</span>
            </template>
          </v-radio>
          <v-radio color="blueDark" value="multi">
            <template v-slot:label>
              <span class="#333--text font-weight-medium mx-2" style="letter-spacing: 1.5px;">Multi city</span>
            </template>
          </v-radio>
        </v-radio-group>
        <v-col cols="12" sm="3" md="2">
          <v-select
          :items="classes"
          v-model="classType"
          item-text="text"
          item-value="value"
          color="blueDark"
          return-object
          item-color="blue"
          @change="setClass"
          >
            <template v-slot:selection="{ item }">
              <span class="blueDark--text">
                {{item.text}}
              </span>
            </template>
          </v-select>
        </v-col>
      </v-row>

      <!-- inputs section -->
      <v-row no-gutters>

        <v-col cols="12" md="5">
        <!-- autocomplete components of one way and round trips -->
          <v-row no-gutters>
            <cities type="Departure"></cities>
            <cities type="Arrival" @setSecondDeparture="setSecondDeparture"></cities>
          </v-row>
        <!-- datepickers components for round trips -->
          <v-row no-gutters class="d-flex d-md-none">
            <v-col cols="12" :sm="flightType === 'round' ? 6 : 12" class="py-0 my-0">
              <picker type="Departure Date" :min="tomorrow"></picker>
            </v-col>
            <v-col cols="12" sm="6" class="py-0 my-0">
              <picker type="Return Date" v-if="flightType === 'round'"></picker>
            </v-col>
          </v-row>
        <!-- second autocomplete components for multi -->
          <v-row no-gutters v-if="flightType === 'multi'">
            <cities type="Second Departure" :getSecondDeparture="secondDeparture"></cities>
            <cities type="Second Arrival" @setThirdDeparture="setThirdDeparture"></cities>
          </v-row>
        <!-- second datepickers component for multi -->
          <v-row no-gutters v-if="flightType === 'multi'" class="d-flex d-md-none">
            <v-col cols="12" class="py-0 my-0">
              <picker type="Second Departure Date" :min="tomorrow"></picker>
            </v-col>
          </v-row>
        <!-- third autocomplete components for multi -->
          <v-row no-gutters v-if="flightType === 'multi' && segments">
            <cities type="Third Departure" :getThirdDeparture="thirdDeparture"></cities>
            <cities type="Third Arrival"></cities>
          </v-row>
        <!-- third datepickers component for multi -->
          <v-row no-gutters v-if="flightType === 'multi' && segments" class="d-flex d-md-none">
            <v-col cols="12" class="py-0 my-0">
              <picker type="Third Departure Date" :min="tomorrow"></picker>
            </v-col>
          </v-row>
        <!-- button for adding a travel segment -->
          <v-btn text color="success" v-if="flightType === 'multi' && !segments" class="d-block d-md-none btn mb-5" @click="segments = !segments">
            <v-icon left>mdi-plus-circle</v-icon>
            Add a segment
          </v-btn>
        <!-- button for removing a travel segment -->
          <v-btn text color="error" v-if="flightType === 'multi' && segments" class="d-block d-md-none btn mb-5" @click="removeSegment">
            <v-icon left>mdi-close-circle</v-icon>
            Remove this segment
          </v-btn>
        </v-col>

        <!-- date picker component on medium and up screens -->
        <v-col cols="12" md="5">
          <v-row no-gutters class="d-none d-md-flex">
            <v-col cols="12" :md="flightType === 'round' ? 6 : 12" class="py-0 my-0">
              <picker type="Departure Date" :min="tomorrow"></picker>
            </v-col>
            <v-col cols="12" md="6" class="py-0 my-0">
              <picker type="Return Date" v-if="flightType === 'round'"></picker>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="flightType === 'multi'" class="d-none d-md-flex" style="position: relative;">
            <v-col cols="12" :md="segments === true ? 12 : 12" class="py-0 my-0">
              <picker type="Second Departure Date" :min="tomorrow"></picker>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn icon x-large color="green lighten-1" v-if="!segments" @click="segments = !segments" style="position: absolute; top: 1px; left: 100%;"><v-icon>mdi-plus-circle</v-icon></v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters v-if="(flightType === 'multi' && segments)" class="d-none d-md-flex" style="position: relative;">
            <v-col cols="12" :md="segments === true ? 12 : 12" class="py-0 my-0">
              <picker type="Third Departure Date" :min="tomorrow"></picker>
            </v-col>
            <v-col cols="12" md="1">
              <v-btn icon x-large color="red lighten-1" @click="removeSegment" style="position: absolute; top: 1px; left: 100%;"><v-icon>mdi-close-circle</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-col>

        <!-- passengers info component -->
        <v-col cols="12" md="2" style="height: 73px">
          <passengers/>
        </v-col>

        <!-- <cities class="d-flex d-md-none" type="airline"></cities> -->

        <!-- submit button -->
        <!-- <v-col cols="12" md="1">
          <v-btn
          tile
          class="white--text search"
          block
          :color="$store.state.mode === 'ats' || $store.state.mode === 'adam' || $store.state.mode === 'atsDev' || $store.state.mode === 'adamDev' ? 'orange' : 'secondary'"
          height="52"
          @click="submit"
          :loading="loading"
          id="flights-search-submit"
          >
          search
          </v-btn>
        </v-col> -->
        <!-- <cities class="d-none d-md-flex" type="airline"></cities> -->
        <cities type="airline"></cities>
        <v-switch
        v-if="flightType !== 'multi'"
        v-model="directFlights"
        inset
        label="Direct Flights"
        class="mx-5"
        color="blueDark"
        ></v-switch>
      </v-row>
    </v-form>
    <v-row justify="center" no-gutters>
      <v-btn
      class="white--text rounded-lg px-10"
      :color="$store.state.mode === 'ats' || $store.state.mode === 'adam' || $store.state.mode === 'atsDev' || $store.state.mode === 'adamDev' ? 'orange' : 'blueDark'"
      height="52"
      @click="submit"
      :loading="loading"
      id="flights-search-submit"
      >
      search
      </v-btn>
    </v-row>
  </div>
</template>

<script>
import cities from './citiesAutocomplete.vue'
import picker from './datePicker.vue'
import passengers from './passengersInfo'

export default {
  components: {
    cities,
    picker,
    passengers
  },
  props: ['loading'],
  data () {
    return {
      flightType: 'round',
      today: new Date().toISOString().substr(0, 10),
      size: '6',
      secondDeparture: null,
      thirdDeparture: null,
      segments: true,
      snackbar: false,
      text: '',
      color: '',
      classType: { text: 'Economy', value: 'Y' },
      classes: [
        { text: 'Economy', value: 'Y' },
        { text: 'Premium', value: 'S' },
        { text: 'Business', value: 'C' },
        { text: 'First', value: 'F' }
      ],
      directFlights: false
    }
  },
  watch: {
    flightType (val) {
      if (val !== 'round') {
        this.size = '11'
      } else {
        this.size = '6'
      }
    }
  },
  computed: {
    tomorrow () {
      const tomorrow = new Date(this.today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      return tomorrow.toISOString().slice(0, 10)
    }
  },
  methods: {
    setClass () {
      this.$store.dispatch('setPassengersClass', this.classType)
    },
    setSecondDeparture (value) {
      this.secondDeparture = value
    },
    setThirdDeparture (value) {
      this.thirdDeparture = value
    },
    removeSegment () {
      this.segments = !this.segments
      this.$store.dispatch('removeSegment')
    },
    submit () {
      const searchStore = this.$store.state
      const searchParameters = {
        tripType: this.flightType
      }
      this.$store.dispatch('setType', this.flightType)
      let data = ''
      let string = ''
      if (new Date(searchStore.flightDates.departureDates[0]).getTime() > new Date().getTime()) {
        if (new Date(searchStore.flightDates.departureDates[0]).getTime() <= new Date(searchStore.flightDates.arrivalDate).getTime() || this.flightType !== 'round') {
          switch (this.flightType) {
            case 'round':
              if (searchStore.airports.departureAirports[0] &&
                  searchStore.airports.arrivalAirports[0] &&
                  searchStore.flightDates.departureDates[0] &&
                  searchStore.flightDates.arrivalDate
              ) {
                searchParameters.origin = searchStore.airports.departureAirports[0].Code
                searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                searchParameters.originType = searchStore.airports.departureAirports[0].Type
                searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                searchParameters.arrivalDate = searchStore.flightDates.arrivalDate
                searchParameters.classType = searchStore.passengers.classType.value
                searchParameters.adults = searchStore.passengers.adults
                searchParameters.children = searchStore.passengers.children
                searchParameters.infants = searchStore.passengers.infants
                if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                searchParameters.directFlights = this.directFlights ? 1 : 0
                data = Object.entries(searchParameters).map(
                  ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                ).join('&')
                this.request(data)
              } else {
                this.snackbar = true
                this.color = 'error'
                this.text = 'Please fill all fields'
              }
              break
            case 'one':
              if (searchStore.airports.departureAirports[0] &&
                  searchStore.airports.arrivalAirports[0] &&
                  searchStore.flightDates.departureDates[0]
              ) {
                searchParameters.origin = searchStore.airports.departureAirports[0].Code
                searchParameters.destination = searchStore.airports.arrivalAirports[0].Code
                searchParameters.originType = searchStore.airports.departureAirports[0].Type
                searchParameters.destinationType = searchStore.airports.arrivalAirports[0].Type
                searchParameters.departureDate = searchStore.flightDates.departureDates[0]
                searchParameters.classType = searchStore.passengers.classType.value
                searchParameters.adults = searchStore.passengers.adults
                searchParameters.children = searchStore.passengers.children
                searchParameters.infants = searchStore.passengers.infants
                if (searchStore.preferredAirline) searchParameters.preferredAirline = searchStore.preferredAirline.code
                searchParameters.directFlights = this.directFlights ? 1 : 0
                data = Object.entries(searchParameters).map(
                  ([key, val]) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`
                ).join('&')
                this.request(data)
              } else {
                this.snackbar = true
                this.color = 'error'
                this.text = 'Please fill all fields'
              }
              break
            case 'multi':
              if ((!this.segments &&
                  searchStore.airports.departureAirports[0] &&
                  searchStore.airports.departureAirports[1] &&
                  searchStore.airports.arrivalAirports[0] &&
                  searchStore.airports.arrivalAirports[1] &&
                  searchStore.flightDates.departureDates[0] &&
                  searchStore.flightDates.departureDates[1]) ||
                  (this.segments &&
                  searchStore.airports.departureAirports[0] &&
                  searchStore.airports.departureAirports[1] &&
                  searchStore.airports.departureAirports[2] &&
                  searchStore.airports.arrivalAirports[0] &&
                  searchStore.airports.arrivalAirports[1] &&
                  searchStore.airports.arrivalAirports[2] &&
                  searchStore.flightDates.departureDates[0] &&
                  searchStore.flightDates.departureDates[1] &&
                  searchStore.flightDates.departureDates[2])
              ) {
                searchParameters.origin = searchStore.airports.departureAirports
                searchParameters.destination = searchStore.airports.arrivalAirports
                searchParameters.departureDate = searchStore.flightDates.departureDates
                searchParameters.classType = searchStore.passengers.classType.value
                searchParameters.adults = searchStore.passengers.adults
                searchParameters.children = searchStore.passengers.children
                searchParameters.infants = searchStore.passengers.infants
                string = 'tripType=multi'
                for (let i = 0; i < searchParameters.origin.length; i++) {
                  if (i === 2 && searchParameters.origin[2] === null) {
                    continue
                  }
                  string += `&origin[]=${searchParameters.origin[i].Code}&originType[]=${searchParameters.origin[i].Type}&destination[]=${searchParameters.destination[i].Code}&destinationType[]=${searchParameters.destination[i].Type}&departureDate[]=${searchParameters.departureDate[i]}`
                }
                string += `&classType=${searchParameters.classType}&adults=${searchParameters.adults}&children=${searchParameters.children}&infants=${searchParameters.infants}`
                string += `&directFlights=${this.directFlights ? 1 : 0}`
                if (searchStore.preferredAirline) string += `&preferredAirline=${searchStore.preferredAirline.code}`
                this.request(string)
              } else {
                this.snackbar = true
                this.color = 'error'
                this.text = 'Please fill all fields'
              }
              break
            default:
              break
          }
        } else {
          this.snackbar = true
          this.color = 'error'
          this.text = 'Please choose departure date before the arrival date you chose'
        }
      } else {
        this.snackbar = true
        this.color = 'error'
        this.text = 'Please choose departure date starting after today'
      }
    },
    request (data) {
      this.$store.dispatch('setFlightsTimeOut', false)
      this.$store.dispatch('setDirectFlights', this.directFlights)
      if (this.$store.state.flightsSearchTimeOutFunction !== null) this.$store.dispatch('clearFlightsSearchTimeoutFunction')
      if (this.$store.state.flightsTimeOutFunction !== null) this.$store.dispatch('clearFlightsTimeoutFunction')
      this.$store.dispatch('removeFlightResults')
      let path
      const searchStore = this.$store.state
      switch (this.flightType) {
        case 'one':
          path = `from=${searchStore.airports.departureAirports[0].Name}-to=${searchStore.airports.arrivalAirports[0].Name}`
          break
        case 'round':
          path = `from=${searchStore.airports.departureAirports[0].Name}-to=${searchStore.airports.arrivalAirports[0].Name}`
          break
        case 'multi':
          for (let i = 0; i < searchStore.airports.departureAirports.length; i++) {
            switch (i) {
              case 0:
                path = `from1=${searchStore.airports.departureAirports[0].Name}-to1=${searchStore.airports.arrivalAirports[0].Name}`
                break
              case 1:
                path += `&from2=${searchStore.airports.departureAirports[1].Name}-to2=${searchStore.airports.arrivalAirports[1].Name}`
                break
              case 2:
                if (searchStore.airports.departureAirports[2]) {
                  path += `&from3=${searchStore.airports.departureAirports[2].Name}-to3=${searchStore.airports.arrivalAirports[2].Name}`
                }
                break
            }
          }
          break
      }
      if (this.$route.name === 'flightResults') {
        this.$emit('addFlights', data)
        this.$route.params.query = path
      } else this.$router.push({ name: 'flightResults', params: { term: data, query: path } })
    }
  },
  created () {
    this.$store.state.flightType === '' ? this.flightType = 'round' : this.flightType = this.$store.state.flightType
    if (this.$store.state.isDirectFlights) this.directFlights = this.$store.state.isDirectFlights
    if (this.$route.name === 'flightResults' && !this.$store.state.airports.arrivalAirports[2]) this.segments = false
    this.classType = this.$store.state.passengers.classType
  }
}
</script>
